import { borrowerService } from "@/modules/contacts/features/borrower/store/services/borrower-service";
import { BORROWER_SERVICE_TAG } from "@/modules/contacts/features/borrower/utils/borrower-service-tags";

const getBorrower = borrowerService.injectEndpoints({
  endpoints: builder => ({
    getBorrower: builder.query({
      query: id => `borrowers/${id}`,
      providesTags: (result, error, id) => [{ type: BORROWER_SERVICE_TAG, id }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetBorrowerQuery } = getBorrower;

